import {
  IncomingMessage,
  LastMessage,
  MediaMessage,
  Message,
  MESSAGE_TYPE,
  TextMessage,
} from 'interfaces/Pages/Messaging';

/**
 * Transform incoming message to last message shape
 *
 * @param message - {@link IncomingMessage}
 */
const transformIncomingMessageToLastMessageShape = (
  message: IncomingMessage,
): LastMessage => {
  return {
    category: message.category,
    conversationId: message.conversationId,
    data: message.data as unknown as LastMessage['data'],
    id: message.id,
    receiver: message.receiver.uid,
    receiverType: message.receiverType,
    sender: message.sender.uid,
    sentAt: message.sentAt,
    type: message.type,
    updatedAt: message.updatedAt,
    deliveredAt: message.deliveredAt,
    readAt: message.readAt,
  };
};

/**
 * Transform message to last message shape
 *
 * @param message - {@link Message}
 * @returns - {@link LastMessage}
 */
const transformMessageToLastMessageShape = (message: Message): LastMessage => {
  let obj: LastMessage = {
    category: message.category,
    conversationId: message.conversationId,
    data: message.data as unknown as LastMessage['data'],
    id: message.id,
    receiver: message.receiver,
    receiverType: message.receiverType,
    sender: message.sender,
    sentAt: message.sentAt,
    type: message.type,
    updatedAt: message.updatedAt,
    deliveredAt: message.deliveredAt,
    readAt: message.readAt,

    tempId: message?.tempId,
    status: message?.status,
  };
  if (message.type === MESSAGE_TYPE.TEXT) {
    obj = {
      ...obj,
      data: {
        text: message.data?.text,
      } as unknown as LastMessage['data'],
    };
  }
  return obj;
};

/**
 * Transform incoming message to message shape
 *
 * @param message - {@link Message}
 */
const transformIncomingMessageToMessageShape = (
  message: IncomingMessage,
): Message => {
  return {
    id: message.id,
    conversationId: message.conversationId,
    sender: message.sender.uid,
    receiverType: message.receiverType,
    receiver: message.receiver.uid,
    category: message.category,
    sentAt: message.sentAt,
    deliveredAt: message?.deliveredAt,
    readAt: message?.readAt,
    updatedAt: message?.updatedAt,
    type: message.type as unknown as TextMessage['type'] | MediaMessage['type'],
    data: message.data as unknown as TextMessage['data'] | MediaMessage['data'],
  } as Message;
};
export {
  transformIncomingMessageToLastMessageShape,
  transformIncomingMessageToMessageShape,
  transformMessageToLastMessageShape,
};

const blobUrlCache: Record<string, string> = {};

export const getBlobUrlFromCache = (id: string): string | undefined => {
  return blobUrlCache[id];
};

export const setBlobUrlToCache = (id: string, url: string) => {
  blobUrlCache[id] = url;
};

export const revokeBlobUrl = (id: string) => {
  const url = blobUrlCache[id];
  if (url) {
    URL.revokeObjectURL(url);
    delete blobUrlCache[id];
  }
};
